<template lang="pug">
    v-dialog(v-model='dialog' scrollable persistent max-width='750px')
        template(v-slot:activator='{ on }')
            v-btn.white--text(
                v-on='on'
                color="error"
                width="125px"
            )
                v-icon mdi-trash-can-outline
                | Archive
        v-card.mx-lg-auto(width="100%")
            v-card-title
                span.text-h5 Remove Scorecard
            v-card-text
                v-container
                    span.text-h6 Are you sure you want to remove this scorecard?

                v-container
                    v-simple-table
                        template(v-slot:default)
                            thead
                                tr
                                    th Name
                            tbody
                                tr(v-if="validScorecard" :key='scorecard.scorecard_id')
                                    td.no-wrap.xs-width
                                        template(v-if="scorecard.name && scorecard.name.length > 0")
                                            StrLimitTooltipText(:text="scorecard.name" :char-limit="50")

            v-card-actions.text-right
                v-spacer
                    v-btn.ma-2(color="var(--volie-blue)" outlined ripple @click='dialog = false;')
                        v-icon mdi-window-close
                        | Close
                    v-btn.ma-2(color="red" outlined ripple :disabled="!validScorecard" :loading="isSaving" @click='destroyScorecard();')
                        v-icon mdi-content-save
                        | Archive

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";

    // Data
    import { DestroyScorecard, } from "@/data";

    export default Vue.extend({
        data() {
            return {
                dialog: false,
                isSaving: false,
            }
        },
        methods: {
            destroyScorecard() {
                if (!this.validScorecard) {
                    return;
                }

                this.isSaving = true;
                DestroyScorecard(this.scorecard.scorecard_id).then((response) => {
                    if (!(response?.Error?.length > 0)) {

                        this.handleDestroyScorecard(this.scorecard);
                        this.showSnackbar("green", "Successfully deleted scorecard");
                    } else {
                        this.showSnackbar("error", "Failed to delete scorecard");
                    }

                    this.isSaving = false;
                    this.dialog = false;
                });
            },
        },
        computed: {
            validScorecard() {
                return this.scorecard?.scorecard_id > 0;
            },
        },
        props: {
            handleDestroyScorecard: Function,
            scorecard: Object,
            showSnackbar: Function,
        },
        components: {
            StrLimitTooltipText,
        },
    });
</script>

<style lang="scss" scoped>
</style>
